/**
 * Coordinates typed or stored as text ("lat, lng").
 */

const COORDINATES_PATTERN = /^\s*(-?\d{1,2}(?:\.\d+)?)\s*[,;\s]\s*(-?\d{1,3}(?:\.\d+)?)\s*$/;

/**
 * Read "lat, lng" text: typed in the address search (the old widget accepted it too) or stored as "{lat},{lng}"
 * @param input Typed text
 * @returns The coordinates, or null when the text is not a valid pair
 */
export const parseCoordinates = (input: string): google.maps.LatLngLiteral | null => {
  const match = COORDINATES_PATTERN.exec(input ?? "");

  if (!match) return null;

  const lat = Number(match[1]);
  const lng = Number(match[2]);

  if (Number.isNaN(lat) || Number.isNaN(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;

  return { lat, lng };
};
